export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11553.8ae4da39.jpg";